/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { ClientId } from '../../models/client-id';
import { LowestPriceForFlights } from '../../models/lowest-price-for-flights';

export interface GetPricesForFlights$Params {

/**
 * IATA codes for airports, cities
 */
  departureLocationCodes: Array<string>;

/**
 * IATA codes for airports, cities
 */
  destinationLocationCodes: Array<string>;

/**
 * Show prices starting from this date (yyyy-MM-dd)
 */
  departureDate?: string;

/**
 * Number of days to search forward from given start date
 */
  numberOfDays?: number;

/**
 * Length of stay
 */
  lengthOfStay?: string;

/**
 * Travel classes
 */
  travelClasses?: Array<string>;

/**
 * Request oneway trip
 *
 * @deprecated
 */
  oneway?: boolean;

/**
 * Trip types
 */
  tripTypes?: Array<string>;

/**
 * locale
 */
  locale?: string;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
}

export function getPricesForFlights(http: HttpClient, rootUrl: string, params: GetPricesForFlights$Params, context?: HttpContext): Observable<DapiHttpResponse<LowestPriceForFlights>> {
  const rb = new DapiRequestBuilder(rootUrl, getPricesForFlights.PATH, 'get');

  if (params) {
    rb.query('departureLocationCodes', params.departureLocationCodes, {"explode":false});
    rb.query('destinationLocationCodes', params.destinationLocationCodes, {"explode":false});
    rb.query('departureDate', params.departureDate, {});
    rb.query('numberOfDays', params.numberOfDays, {});
    rb.query('lengthOfStay', params.lengthOfStay, {});
    rb.query('travelClasses', params.travelClasses, {"explode":false});
    rb.query('oneway', params.oneway, {});
    rb.query('tripTypes', params.tripTypes, {"explode":false});
    rb.query('locale', params.locale, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<LowestPriceForFlights>;
    }),
    catchErrorAsJson()
  );
}

getPricesForFlights.PATH = '/api/instantsearch/prices/flights';
